export default __webpack_public_path__ + "static/media/releaseNotes.9a0a176b.md";